import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-postula-ver-becario',
  templateUrl: './postula-ver-becario.component.html',
  styleUrls: ['./postula-ver-becario.component.css']
})
export class PostulaVerBecarioComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecPostulaciones = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private alerti: AlertifyService, private ruta: Router) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarBecas();
  }

  //FUNCION QUE CARGA TODAS LAS POSTULACIONES DEL ESTUDIANTE
  async cargarBecas() {
    this.cargando.abrir();
    var totalReq = 0; var totalApl = 0;
    this.vecPostulaciones = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(11, localStorage.getItem('ciUsuario'), localStorage.getItem('localCarrera'), 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objBeca of res.becas) {
        if (objBeca.strPeriodo == localStorage.getItem('localPeriodo')) {
          totalReq = 0; totalApl = 0;
          const resRequisito = await new Promise<any>(resolve =>
            this.srvSelect.gestionRequisitos(8, objBeca.intIdTipoBecas, objBeca.intIdBecas, objBeca.strPeriodo).subscribe(translated => {
              resolve(translated)
            }));
          totalReq = resRequisito['success'] == true ? resRequisito.especifico.length : 0;

          const resAplica = await new Promise<any>(resolve =>
            this.srvSelect.gestionRequisitos(9, objBeca.intIdAplica, 'na', 'na').subscribe(translated => {
              resolve(translated)
            }));

          totalApl = resAplica['success'] == true ? resAplica.especifico.length : 0;
        }
        this.vecPostulaciones.push({
          idBeca: objBeca.intIdBecas, beca: objBeca.strNombre, detBeca: objBeca.strDescripcion, idTipoBeca: objBeca.intIdTipoBecas, tipoBeca: objBeca.tipoBeca,
          idAplica: objBeca.intIdAplica, estudiante: objBeca.codigoEstudiante, fecha: objBeca.fecha.split('T')[0], periodo: objBeca.strPeriodo,
          carrera: objBeca.strCarrera, facultad: objBeca.strFacultad, estPostula: objBeca.intEstado,

          progreso: objBeca.strPeriodo == localStorage.getItem('localPeriodo') ? Math.trunc((totalApl / totalReq) * 100) + '% completado' : objBeca.intEstado == 1 ? 'Aprobado' : objBeca.intEstado == 2 ? 'Rechazado' : 'Pendiente',

          lblEstado: objBeca.strPeriodo == localStorage.getItem('localPeriodo') ? 'Vigente' : 'No Vigente',
          aprobado: objBeca.intEstado == 1 ? 'Aprobado' : objBeca.intEstado == 2 ? 'Pre-aprobado' : objBeca.intEstado == 3 ? 'Pendiente' : 'Rechazado'
        });
      }
    }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  verAplicaReq(objRequisito) {
    if (localStorage.getItem('localPeriodo') == objRequisito['periodo']) {
      if (objRequisito['estPostula'] != 4) {
        localStorage.setItem('localIdBeca', objRequisito['idTipoBeca']);
        localStorage.setItem('localNomBeca', objRequisito['tipoBeca']);
        localStorage.setItem('localBecaPer', objRequisito['periodo']);
        localStorage.setItem('localBecaIdA', objRequisito['idAplica']);
        localStorage.setItem('localTipoBeca', objRequisito['idBeca']);
        this.ruta.navigate(["/becario/postulaBecas"]);
      }
      else
        this.alerti.error('La postulación ha sido rechazada por parte de un analista de bienestar politécnico');
    }
    else
      this.alerti.error('La postulación seleccionada corresponde a un período anterior');
  }
}
